import { useQueryClient } from "@tanstack/react-query";

import { useCurrentWorkspace } from "src/api/queries";
import { type DashboardPageParams } from "src/router/urls";
import type { EntityResolutionContext } from "src/unifiedCopilot/context/entityResolution";
import { useContextualEntities } from "src/unifiedCopilot/context/internalHooks";
import { useParamsDecode } from "src/utils/useParamsDecode";

/**
 * What resolving a ref needs from the page around it, or null until the
 * workspace query has landed. The workspace is read through the query rather
 * than the route outlet context: mention pills render inside the copilot
 * window, which sits outside the routed page tree.
 */
export const useEntityResolutionContext =
  (): EntityResolutionContext | null => {
    const { orgId, wsId } = useParamsDecode<DashboardPageParams>();
    const entities = useContextualEntities();
    const queryClient = useQueryClient();
    const { data: workspace } = useCurrentWorkspace();

    return orgId && wsId && workspace
      ? { orgId, wsId, workspace, entities, queryClient }
      : null;
  };
